"use client";

import clsx from "clsx";
import { usePathname } from "next/navigation";

import { NextLink } from "@/app/lib/components/next/NextLink";

import classes from "./AudiencePill.module.css";

/** The agent-facing front door; every other marketing route is the human one. */
const AGENTS_PATH = "/agents";

const AUDIENCES = [
  { label: "Human", href: "/" },
  { label: "Agent", href: AGENTS_PATH },
] as const;

/** The site's two readers, as two links: Human is the whole marketing site,
    Agent is the /agents page. The lit dot follows the current path. Two
    anchors and a pathname check, no client state and no mode to switch. */
export default function AudiencePill() {
  const pathname = usePathname();
  const isOnAgentsPage = pathname === AGENTS_PATH || pathname.startsWith(`${AGENTS_PATH}/`);

  return (
    <nav aria-label="Audience" className={classes.pill}>
      {AUDIENCES.map((audience) => {
        const isActive = (audience.href === AGENTS_PATH) === isOnAgentsPage;

        return (
          <NextLink
            key={audience.href}
            href={audience.href}
            className={clsx(classes.link, isActive && classes.linkActive)}
            aria-current={isActive ? "page" : undefined}
          >
            <span className={clsx(classes.dot, isActive && classes.dotActive)} aria-hidden />
            {audience.label}
          </NextLink>
        );
      })}
    </nav>
  );
}
